import { initialize } from 'vue-ld';
import { useCmsAiStore } from '../stores/cmsAiStore.js';

export default defineNuxtPlugin(async ({ provide }) => {
  if (import.meta.server) {
    provide('ld', { flags: {} });
    return;
  }

  const cmsAiStore = useCmsAiStore();

  const loadLaunchDarkly = async () => {
    const clientId = cmsAiStore.clientId;
    const ldClientKey = useRuntimeConfig().public.LAUNCH_DARKLY_KEY;
    try {
      if (ldClientKey && clientId) {
        const $ld = initialize({
          clientSideId: ldClientKey,
          user: {
            key: 'cms-public',
            anonymous: true,
            custom: {
              client_id: clientId && `urn:apptegy:global:sso:client:${clientId}`,
              entity_type: 'staff',
            },
          },
        });
        // Provide immediately so hydration is not blocked. Feature flags for the
        // initial render come from the Pinia store (set server-side). LD will update
        // reactively once the client is ready.
        provide('ld', $ld);
        $ld.ldClient.waitUntilReady().catch(console.error);
      } else {
        provide('ld', { flags: {} });
      }
    } catch (error) {
      console.error(error);
      provide('ld', { flags: {} });
    }
  };
  await loadLaunchDarkly();
});
